import React from "react";
import { useSelector } from "react-redux";
import theme from "../../config/theme";

interface Option {
  label: string;
  value: string | any;
}

interface SelectProps {
  name?: string;
  options?: Option[];
  value?: any;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  radius?: string;
  error?: string;
  helperText?: string;
}

const Select: React.FC<SelectProps> = ({
  name,
  options,
  value,
  onChange,
  onBlur,
  placeholder = "یک گزینه را انتخاب کنید",
  disabled = false,
  required = false,
  className = "",
  radius = "5px",
  error,
  helperText,
}) => {
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  return (
    <div className="w-full">
      <div className=" rounded-md max-h-[35px] w-full">
        <select
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          required={required}
          className={`peer block w-full rounded-md border py-2 px-3 mb-1 focus:outline-none focus:bg-white focus:shadow-[0_0px_4px_#03797d73] focus:border-[#028d91] !text-right disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 !text-[12px] ${
            error ? "border-red-500" : "border-[#9D9D9D]"
          } ${className}`}
          style={{
            borderRadius: radius,
            backgroundColor: mode.backgroundColor.bgSecondary,
            color: mode.color.textPrimary,
          }}
        >
          <option value="">{placeholder}</option>
          {options &&
            options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
        </select>
      </div>
      {(helperText || error) && (
        <p className="text-right w-full text-[9px] text-mobasher-red mt-1">
          * {error || helperText}
        </p>
      )}
    </div>
  );
};

export default Select;
